import { richTextResolver } from "@website-builder/utilities-index";

export default (
	{ header, content, headerSize, gridClass },
	{ globalVariableWithURL = [] },
) => {
	const contentInHtml = richTextResolver(content, globalVariableWithURL);
	return {
		header,
		headerSize: headerSize,
		contentInHtml,
		gridClass: convertGridClass(gridClass),
	};
};

const convertGridClass = (gridClass = {}) => {
	let bootStrapClass = "";
	const tags = gridClass.tags;
	if (tags && tags.length) {
		tags.forEach(({ text }) => {
			bootStrapClass = `${bootStrapClass} ${text}`;
		});
	}
	return bootStrapClass;
};
